module.exports = __webpack_public_path__ + "img/Logo2.02aaca7e.jpg";